import { businessErrorFactory, BusinessError } from '../../../../common/business-error';

const CREATE_AN_ORDER_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and your order could not be created. Please try again. If the problem still persists, contact with support.';

const OPERATION_ALREADY_EXISTS =
  // eslint-disable-next-line max-len
  'Sorry, but this order already exist. Please refresh page and try again. If the problem still persists, contact with support.';

const OPERATION_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry, but we could not find your order. Please refresh page and try again. If the problem still persists, contact with support.';

export enum BUSINESS_ERRORS {
  'OPERATION_NOT_FOUND' = 'OPERATION_NOT_FOUND',
  'OPERATION_ALREADY_EXISTS' = 'OPERATION_ALREADY_EXISTS'
}

export const getCreateAnOrderBusinessError = (businessError: BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.OPERATION_NOT_FOUND: {
      return businessErrorFactory({ message: OPERATION_NOT_FOUND, severity: 'error' });
    }
    case BUSINESS_ERRORS.OPERATION_ALREADY_EXISTS: {
      return businessErrorFactory({ message: OPERATION_ALREADY_EXISTS, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({
        message: CREATE_AN_ORDER_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
